import React from "react";
import { Link } from "react-router-dom";
import { IconType } from "react-icons";
import './MenuMobileItem.scss';

type MenuMobileItemProps = {
    label: string,
    icon: IconType,
    to: string,
    active?: boolean,
    disabled?: boolean,
};

function MenuMobileItem(props: MenuMobileItemProps) {

    return (
        <Link to={props.disabled ? '#' : props.to} className={`nostyle menu-mobile-item ${props.active ? 'active' : ''} ${props.disabled ? 'disabled' : ''}`}>
            {React.createElement(props.icon, { size: '1.5rem' })}
            <div className="menu-mobile-item-label">
                {props.label}
            </div>
        </Link>
    );
}

export default MenuMobileItem;
